import { Card } from '@mui/material';
import React from 'react';

export const PaywallCard = ({ children }: { children: React.ReactNode }) => {
  return <Card sx={{ width: 240 }}>{children}</Card>;
};
